// @flow
import React from 'react';
import Group from 'sail/Group';
import {usePrefs} from 'docs/data';
import {ClientSetting} from './components/ClientSetting';
import {ServerSetting} from './components/ServerSetting';

export const WEB_WITH_NEXT_SETTINGS = {
  platforms: ['web'],
  clients: {web: ['html', 'react', 'next']},
  servers: ['ruby', 'node', 'php', 'python', 'go', 'dotnet', 'java'],
};

export const WebWithNextSettings = () => {
  const {getPref} = usePrefs();
  const clientPref = getPref('client');
  const showServers = clientPref ? clientPref !== 'next' : true;

  return (
    <Group direction="horizontal" alignItems="center" spacing={24}>
      <ClientSetting clients={WEB_WITH_NEXT_SETTINGS.clients} />
      {showServers && (
        <ServerSetting servers={WEB_WITH_NEXT_SETTINGS.servers} />
      )}
    </Group>
  );
};
